import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as actions from '../actions/micustomeractions'
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
export default function PaymentResult() {

    const { register, handleSubmit, reset, setValue, watch, formState: { errors }, clearErrors } = useForm();
    const state = useSelector(state => state.miCustomerSharedReducer);
    const dispatch = useDispatch();

    let paymentInformation = state.paymentInformation;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const referenceId = urlParams.get('referenceId');
    const success = urlParams.get('success') == "True" ? true : false;
    const error = urlParams.get('errors');
    const navigate = useNavigate();
    console.log("queryString", queryString);

    useEffect(() => {
        async function GetPaymentInformation() {
            if (referenceId != null) {

                await dispatch(actions.getPaymentInformationByEncryptedReferenceId(referenceId));
            }
        }
        GetPaymentInformation();
        console.log('paymentInformation', paymentInformation);

    }, []);


    useEffect(() => {
        let valuesToMap = [
            { "customerEmail": paymentInformation.customerEmail },
            { "customerPhone": paymentInformation.customerPhone },
            { "customerName": paymentInformation.customerName },
            { "customerEmail": paymentInformation.customerEmail },
            { "description": paymentInformation.description },
            { "amount": paymentInformation.amount },
            { "referenceId": paymentInformation.referenceId },
            { "policyNo": paymentInformation.policyNo }

        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
    }, [paymentInformation]);


    /*   const onSubmitPayment = () => {
          dispatch(actions.onProceedToPay());
      }
   */

    let CustomerName = <input className='form-control'
        type="text" name='customerName' disabled={true}
        {...register('customerName', { required: true })}
    />
    let CustomerPhone = <input className='form-control'
        type="text" name='customerPhone' disabled={true}
        {...register('customerPhone', { required: true })}
    />
    let CustomerEmail = <input className='form-control'
        type="text" name='customerEmail' disabled={true}
        {...register('customerEmail', { required: true })}
    />
    let Description = <input className='form-control'
        type="text" name='description' disabled={true}
        {...register('description', { required: true })}
    />
    let PolicyNo = <input className='form-control'
        type="text" name='policyNo' disabled={true}
        {...register('policyNo', { required: true })}
    />
    let Amount = <input className='form-control'
        type="text" name='amount' disabled={true}
        {...register('amount', { required: true })}
    />
    function renderSuccess() {
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>

                <div className="container">
                    <h4 class="alert-heading text-center text-success">Payment Successful!</h4>
                    <h5 className='text-danger'>* Please Click on Continue Button to finish all information Details</h5>

                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Name</label>
                            </div>
                            <div className="col-9">
                                {CustomerName}
                                <div>

                                </div>

                            </div>

                        </div>

                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Phone</label>
                            </div>
                            <div className="col-9">
                                {CustomerPhone}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Email</label>
                            </div>
                            <div className="col-9">
                                {CustomerEmail}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Quote No</label>
                            </div>
                            <div className="col-9">
                                {Description}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Policy No</label>
                            </div>
                            <div className="col-9">
                                {PolicyNo}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Amount(AED)</label>
                            </div>
                            <div className="col-9">
                                {Amount}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>

                    {error &&
                        <>
                            <p className="text-danger">**Quotation not converted due to internal issue.</p>
                            <p className="text-danger">{error}</p>
                        </>
                    }

                </div>



            </>
        )
    }
    function renderFailure() {
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>

                <div className="container">
                    <h4 class="alert-heading text-center text-danger">Payment Failed!</h4>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Name</label>
                            </div>
                            <div className="col-9">
                                {CustomerName}
                                <div>

                                </div>

                            </div>

                        </div>

                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Phone</label>
                            </div>
                            <div className="col-9">
                                {CustomerPhone}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Email</label>
                            </div>
                            <div className="col-9">
                                {CustomerEmail}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Quote No</label>
                            </div>
                            <div className="col-9">
                                {Description}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Policy No</label>
                            </div>
                            <div className="col-9">
                                {PolicyNo}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row pt-3 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                            <div className=" col-2 text-start">
                                <label className="form-label w-100">Amount(AED)</label>
                            </div>
                            <div className="col-9">
                                {Amount}
                                <div>

                                </div>

                            </div>

                        </div>
                    </div>
                    {error &&
                        <>
                            <p className="text-danger">**Quotation not converted due to internal issue.</p>
                            <p className="text-danger">{error}</p>
                        </>
                    }
                </div>



            </>
        )
    }

    const onContinuePressed = async () => {
        await dispatch(actions.handleContinue())
        navigate(`/FullMemberDetails?encryptedEnquiryRefId1=${encodeURIComponent(paymentInformation?.encryptedEnquiryRefId1)}&encryptedEnquiryRefId2=${encodeURIComponent(paymentInformation?.encryptedEnquiryRefId2)}`)
    }
    return (
        < div className="content" >
            <div className="row">
                <div className="col-12">
                    <div className="card ribbon-box">
                        <div className="card-body">

                            {success &&
                                <>
                                    {renderSuccess()}
                                    <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'center' }}>
                                        <Button
                                            className='mx-6'
                                            variant="contained"
                                            type='button'
                                            color="primary"
                                            size="large"
                                            onClick={() => onContinuePressed()}
                                            endIcon={<ArrowForwardIcon />}

                                        >
                                            Continue
                                        </Button>

                                    </Box>
                                </>

                            }
                            {!success &&
                                renderFailure()
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}